export function formatDateShort(date: Date): string {
    const meses = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
    ];

    const dia = date.getDate();
    const mes = meses[date.getMonth()];

    return `${dia} de ${mes}`;
}